/* AcheterLush — choix des saveurs, tiroir panier et offre spéciale (comme Larine) */
(function () {
  'use strict';

  /* Format d'argent de la boutique (shop.money_format) ---------------------- */
  function formatMoney(cents, fmt) {
    fmt = fmt || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    function group(n, dec, thou, sep) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[1] ? parts[0] + sep + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        default: return group(cents, 2, ',', '.');
      }
    });
  }
  function el(root, sel) { return root.querySelector(sel); }
  function setText(root, sel, txt) { root.querySelectorAll(sel).forEach(function (n) { n.textContent = txt; }); }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; });
    });
  }

  /* ------------------------------------------------------------------------
     Choix des saveurs
     ------------------------------------------------------------------------ */
  document.querySelectorAll('[data-lr-picker]').forEach(function (picker) {
    var fmt = picker.getAttribute('data-money-format');
    var min = parseInt(picker.getAttribute('data-min'), 10) || 2;
    var ship = parseInt(picker.getAttribute('data-ship'), 10) || 0;
    var g2 = picker.getAttribute('data-g2'), g2min = parseInt(picker.getAttribute('data-g2-min'), 10) || 0;
    var g3 = picker.getAttribute('data-g3'), g3min = parseInt(picker.getAttribute('data-g3-min'), 10) || 0;
    var flavors = Array.prototype.slice.call(picker.querySelectorAll('[data-flavor]'));
    var qty = {};

    function totals() {
      var count = 0, price = 0, compare = 0;
      flavors.forEach(function (f) {
        var q = qty[f.dataset.id] || 0;
        count += q; price += q * +f.dataset.price; compare += q * +f.dataset.compare;
      });
      return { count: count, price: price, compare: compare };
    }

    function render() {
      var t = totals();
      flavors.forEach(function (f) {
        var q = qty[f.dataset.id] || 0;
        f.classList.toggle('has-qty', q > 0);
        var n = el(f, '[data-qty]'); if (n) n.textContent = q;
      });

      // Lignes du récapitulatif
      var lines = el(picker, '[data-lines]');
      lines.innerHTML = '';
      flavors.forEach(function (f) {
        var q = qty[f.dataset.id] || 0;
        if (!q) return;
        var row = document.createElement('div');
        row.className = 'lr-picker__line';
        var name = document.createElement('span'); name.textContent = f.dataset.name + ' × ' + q;
        var pr = document.createElement('span');
        pr.innerHTML = '<s></s> <b></b>';
        pr.querySelector('s').textContent = formatMoney(q * f.dataset.compare, fmt);
        pr.querySelector('b').textContent = formatMoney(q * f.dataset.price, fmt);
        row.appendChild(name); row.appendChild(pr); lines.appendChild(row);
      });

      var save = t.compare - t.price;
      setText(picker, '[data-sub-compare]', save > 0 ? formatMoney(t.compare, fmt) : '');
      setText(picker, '[data-sub-price]', formatMoney(t.price, fmt));
      setText(picker, '[data-sub-save]', formatMoney(save, fmt));
      setText(picker, '[data-count-label]', t.count + (t.count > 1 ? ' boîtes' : ' boîte'));
      setText(picker, '[data-foot-compare]', save > 0 ? formatMoney(t.compare, fmt) : '');
      setText(picker, '[data-foot-price]', formatMoney(t.price, fmt));
      setText(picker, '[data-foot-price2]', formatMoney(t.price, fmt));
      setText(picker, '[data-foot-save]', save > 0 ? 'Économisez ' + formatMoney(save, fmt) : '');
      el(picker, '[data-picker-checkout]').disabled = t.count < min;

      // Barre de progression : cadeaux (au nombre de boîtes) puis livraison (au montant)
      var g2ok = !!g2 && t.count >= g2min, g3ok = !!g3 && t.count >= g3min, shipOk = ship > 0 && t.price >= ship;
      picker.querySelectorAll('[data-step]').forEach(function (s) {
        var k = s.getAttribute('data-step');
        s.classList.toggle('is-done', (k === 'g2' && g2ok) || (k === 'g3' && g3ok) || (k === 'ship' && shipOk));
      });
      var stepsDone = (g2ok ? 1 : 0) + (g3ok ? 1 : 0) + (shipOk ? 1 : 0);
      var partial = 0;
      if (!g2ok && g2min) partial = t.count / g2min;
      else if (g2ok && !g3ok && g3min) partial = (t.count - g2min) / Math.max(1, g3min - g2min);
      else if (g3ok && !shipOk && ship) partial = t.price / ship;
      el(picker, '[data-progress-fill]').style.width = Math.min(100, (stepsDone + Math.min(partial, 0.99)) / 3 * 100) + '%';

      var gift2 = picker.querySelector('[data-step="g2"] small').textContent;
      var gift3 = picker.querySelector('[data-step="g3"] small').textContent;
      var title, sub;
      if (g3ok) title = gift2 + ' + ' + gift3 + ' débloqués!';
      else if (g2ok) title = gift2 + ' débloqué!';
      else title = 'Débloquez des cadeaux gratuits';
      if (!g2ok && g2min) sub = 'Ajoutez ' + (g2min - t.count) + ' boîte(s) de plus pour : ' + gift2;
      else if (!g3ok && g3min) sub = 'Ajoutez ' + (g3min - t.count) + ' boîte(s) de plus pour : ' + gift3;
      else if (!shipOk && ship) sub = 'Ajoutez ' + formatMoney(ship - t.price, fmt) + ' de plus pour la livraison gratuite';
      else sub = 'Livraison gratuite débloquée!';
      setText(picker, '[data-progress-title]', '🎁 ' + title);
      setText(picker, '[data-progress-sub]', sub);
    }

    // Répartition par défaut : 2 boîtes par saveur, dans l'ordre (8 boîtes = 4 saveurs × 2)
    function preset(boxes) {
      qty = {};
      var left = boxes;
      flavors.forEach(function (f) {
        if (left <= 0 || f.classList.contains('is-soldout')) return;
        var q = Math.min(2, left); qty[f.dataset.id] = q; left -= q;
      });
      render();
    }

    picker.addEventListener('click', function (e) {
      var f = e.target.closest('[data-flavor]');
      if (f && e.target.closest('[data-plus]')) { qty[f.dataset.id] = (qty[f.dataset.id] || 0) + 1; render(); }
      if (f && e.target.closest('[data-minus]')) { qty[f.dataset.id] = Math.max(0, (qty[f.dataset.id] || 0) - 1); render(); }
    });

    // Ouverture depuis le bouton principal : on reprend le nombre de boîtes de l'ensemble choisi
    document.querySelectorAll('[data-picker-open="' + picker.id + '"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pdp = btn.closest('[data-lr-pdp]');
        var sel = pdp && pdp.querySelector('[data-bundles] input:checked');
        preset(sel ? parseInt(sel.getAttribute('data-boxes'), 10) || min : min);
        picker.hidden = false; document.body.style.overflow = 'hidden';
      });
    });

    el(picker, '[data-picker-checkout]').addEventListener('click', function () {
      var btn = this, t = totals(), err = el(picker, '[data-picker-error]');
      if (t.count < min) return;
      var items = [];
      flavors.forEach(function (f) { var q = qty[f.dataset.id] || 0; if (q) items.push({ id: +f.dataset.id, quantity: q }); });
      if (g2 && t.count >= g2min) items.push({ id: +g2, quantity: 1 });
      if (g3 && t.count >= g3min) items.push({ id: +g3, quantity: 1 });
      btn.disabled = true; err.hidden = true;
      postJSON('/cart/add.js', { items: items })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (e) { err.textContent = e.message; err.hidden = false; btn.disabled = false; });
    });

    render();
  });

  /* ------------------------------------------------------------------------
     Tiroir panier
     ------------------------------------------------------------------------ */
  var drawer = document.querySelector('[data-lr-drawer]');
  if (!drawer) return;
  var dFmt = drawer.getAttribute('data-money-format');
  var dShip = parseInt(drawer.getAttribute('data-ship'), 10) || 0;
  var upsellId = drawer.getAttribute('data-upsell');
  var upsell = document.querySelector('[data-lr-upsell]');
  var lastCart = null;

  function renderCart(cart) {
    lastCart = cart;
    setText(drawer, '[data-drawer-count]', '(' + cart.item_count + ') article' + (cart.item_count > 1 ? 's' : ''));
    document.querySelectorAll('.cart-count').forEach(function (n) { n.textContent = cart.item_count; });
    el(drawer, '[data-drawer-empty]').hidden = cart.item_count > 0;
    el(drawer, '[data-drawer-foot]').hidden = cart.item_count === 0;
    setText(drawer, '[data-drawer-total]', formatMoney(cart.total_price, dFmt));

    var left = dShip - cart.total_price;
    el(drawer, '[data-drawer-ship-fill]').style.width = (dShip ? Math.min(100, cart.total_price / dShip * 100) : 100) + '%';
    el(drawer, '[data-drawer-ship-text]').innerHTML = left > 0
      ? 'Plus que <b>' + formatMoney(left, dFmt) + '</b> pour la <b>LIVRAISON GRATUITE</b>'
      : '🎉 Vous avez débloqué la <b>LIVRAISON GRATUITE</b>!';

    var list = el(drawer, '[data-drawer-items]');
    list.innerHTML = '';
    cart.items.forEach(function (it, i) {
      var li = document.createElement('li');
      li.className = 'lr-drawer__item';
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      li.innerHTML =
        '<img alt="" loading="lazy">' +
        '<div class="lr-drawer__info"><a class="lr-drawer__name"></a><div class="lr-drawer__variant"></div>' +
        '<div class="lr-drawer__row"><div class="lr-qty__ctrl"><button type="button" data-q="-1" aria-label="Diminuer">−</button><span></span><button type="button" data-q="1" aria-label="Augmenter">+</button></div>' +
        '<div class="lr-drawer__price"><s></s> <b></b></div></div></div>' +
        '<button type="button" class="lr-drawer__rm" data-rm aria-label="Retirer">×</button>';
      if (img) li.querySelector('img').src = img; else li.querySelector('img').remove();
      var a = li.querySelector('.lr-drawer__name'); a.textContent = it.product_title; a.href = it.url;
      li.querySelector('.lr-drawer__variant').textContent = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      li.querySelector('.lr-qty__ctrl span').textContent = it.quantity;
      var orig = it.original_line_price, fin = it.final_line_price;
      var cmp = it.variant_compare_at_price ? it.variant_compare_at_price * it.quantity : 0;
      li.querySelector('.lr-drawer__price s').textContent = cmp > fin ? formatMoney(cmp, dFmt) : (orig > fin ? formatMoney(orig, dFmt) : '');
      li.querySelector('.lr-drawer__price b').textContent = fin === 0 ? 'GRATUIT' : formatMoney(fin, dFmt);
      // Cadeaux gratuits : quantité fixe (pas de + / −)
      if (it.original_price === 0) li.querySelector('.lr-qty__ctrl').style.visibility = 'hidden';
      li.dataset.line = i + 1; li.dataset.qty = it.quantity;
      list.appendChild(li);
    });
  }

  function refresh() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart); }
  function openDrawer() { drawer.hidden = false; document.body.style.overflow = 'hidden'; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); }
  function closeDrawer() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { drawer.hidden = true; }, 250); }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    var li = e.target.closest('.lr-drawer__item');
    if (!li) return;
    var q = null;
    if (e.target.closest('[data-rm]')) q = 0;
    var b = e.target.closest('[data-q]');
    if (b) q = Math.max(0, +li.dataset.qty + +b.getAttribute('data-q'));
    if (q === null) return;
    li.style.opacity = '.5';
    postJSON('/cart/change.js', { line: +li.dataset.line, quantity: q }).then(renderCart).catch(refresh);
  });

  // Icône panier de l'en-tête
  document.querySelectorAll('.header__cart').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); refresh().then(openDrawer); });
  });

  // Tous les formulaires « Ajouter au panier » (sauf choix des saveurs) → ajout AJAX + tiroir
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(openDrawer)
      .finally(function () { if (btn) btn.disabled = false; });
  });

  // Passer à la caisse : offre spéciale une seule fois par visite, sinon paiement
  var timer = null;
  function goCheckout() { window.location.href = '/checkout'; }
  function inCart(id) { return lastCart && lastCart.items.some(function (it) { return String(it.variant_id) === String(id); }); }
  function seen() { try { return sessionStorage.getItem('lr-upsell-seen') === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem('lr-upsell-seen', '1'); } catch (e) {} }

  el(drawer, '[data-drawer-checkout]').addEventListener('click', function () {
    if (!upsell || !upsellId || seen() || inCart(upsellId)) { goCheckout(); return; }
    markSeen();
    upsell.hidden = false;
    var end = Date.now() + 180000, out = upsell.querySelector('[data-upsell-timer]');
    clearInterval(timer);
    timer = setInterval(function () {
      var s = Math.max(0, Math.round((end - Date.now()) / 1000));
      out.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      if (!s) clearInterval(timer);
    }, 1000);
  });
  if (upsell) {
    upsell.addEventListener('click', function (e) {
      if (e.target.closest('[data-upsell-decline]')) { upsell.hidden = true; goCheckout(); }
      if (e.target.closest('[data-upsell-accept]')) {
        e.target.disabled = true;
        postJSON('/cart/add.js', { items: [{ id: +upsellId, quantity: 1 }] }).then(goCheckout).catch(goCheckout);
      }
    });
  }
})();
